
import { useEffect, useState } from 'react'
import CurrencyInput from 'react-currency-input-field'

import classes from './InputBoxCurrencyAlternative.module.css'
import { useCanEdit, useUserTabEditPermissionDisabled, useCanEditArchived } from '../../../lib/usersPermissions'


export default function InputBoxCurrencyAlternative({label, name, placeholder, currentValue, action, identifier, isNotModifiable, maxValue}) {
    // let masterDisable = useCanEdit()
    let editArchivedDisabled = useCanEditArchived()
    let userPermissionDisabled = useUserTabEditPermissionDisabled(identifier?.permissionType ? identifier?.permissionType : identifier?.type)
    const [value, setValue] = useState(currentValue)

    function onChange(value, name, values) {  
   
        // setValue(value)

        if (!userPermissionDisabled) {
            if (!maxValue) {
                setValue(value)
            } else {
                if (value > maxValue) {
                    setValue(maxValue)
                } else {
                    setValue(value)
                }
            }
        }

        
    }

    function normalizeCurrencyValue(v) {
        if (v == null || `${v}`.trim() === '') return null
        const cleaned = `${v}`.replace(/[^0-9.-]/g, '')
        if (cleaned === '' || cleaned === '-' || cleaned === '.') return null
        const n = Number(cleaned)
        return Number.isFinite(n) ? n : null
    }

    function onBlur(e) {
   
        if (!userPermissionDisabled) {
            const nextNorm = normalizeCurrencyValue(value)
            const currNorm = normalizeCurrencyValue(currentValue)
            if (action && nextNorm !== currNorm) {
                action({
                    data: {
                        value: value ? value : null
                    },
                    identifier: identifier
                })
            }
        }
        
    }


    
    useEffect(() => {  
        if (currentValue) {
            setValue(currentValue)
        }
    }, [currentValue])


    return <div className={`${classes.input_container}`}>
        {label && <label htmlFor={name} className={`${classes.label}`}>{label}</label>}
        <CurrencyInput
            id={identifier.field + '_' + identifier.type_id}
            name={name}
            placeholder={placeholder}
            // defaultValue={currentValue}
            value={value}
            decimalsLimit={2}
            onValueChange={onChange}
            prefix='$'
            onBlur={onBlur}
            className={classes.input}
            disabled={isNotModifiable || editArchivedDisabled || userPermissionDisabled}
            />
    </div>
}